import IdleTimer from 'exacta-material-react/lib/src/components/IdleTimer';
import { LessonState } from 'nots-window-renderer/lib/helpers/constants';
import React from 'react';
import styled from 'styled-components';

import { Switch, Typography } from '@material-ui/core';
import PauseIcon from '@material-ui/icons/Pause';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';

import { colors } from '../../containers/S80/WindowConfig';
import { IdleTimeout } from '../../helpers/constants';
import {
  minToMillis,
  zeroFilledMinutes,
  zeroFilledSeconds,
} from '../../utils/dateUtils';
import { LessonControllerTitle } from './LessonControllerHelpers';
import MultimediaAndHintReviewList from './MultimediaAndHintReviewList';

const Container = styled.div`
  background: ${colors.primary};
  display: flex;
  height: 100%;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  & > svg {
    cursor: pointer;
    font-size: 100px;
    color: white;
  }
  & > svg.disabled {
    color: gray;
    cursor: not-allowed;
  }
  & > span {
    color: white;
  }
`;

const TimerContainer = styled.div`
  background: ${colors.primary};
  color: white;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonContainer = styled.div<any>`
  & > span {
    color: white;
  }
  display: flex;
  align-item: center;
  justify-content: center;
  & > svg {
    cursor: pointer;
    ${({ system }) => {
      if (system === 's80') {
        return `font-size: 70px;`;
      } else {
        return `font-size: 100px;`;
      }
    }}

    color: white;
  }
  & > svg.disabled {
    color: gray;
    cursor: not-allowed;
  }
  & > span {
    color: white;
  }
`;

const PreferenceSection = styled.div`
  position: fixed;
  z-index: 800;
  left: 15px;
  bottom: 0;
  color: white;
  display: flex;
  align-items: center;
`;

const GraySection = styled.div`
  color: gray;
  margin-right: 5px;
`;

const formatTime = (time) => {
  const minutes = zeroFilledMinutes(time);
  const seconds = zeroFilledSeconds(time);
  return `${minutes}:${seconds}`;
};

const TimerDisplay = ({ timeRemaining, estimatedTime }) => (
  <TimerContainer data-testid="timerContainer">
    <Typography variant="h3">
      {timeRemaining} / {estimatedTime}
    </Typography>
  </TimerContainer>
);

const ControlButtons = ({
  system,
  isLessonStarted,
  pauseLesson,
  stopLesson,
}) => (
  <ButtonContainer system={system}>
    {isLessonStarted ? (
      <PauseIcon data-testid="pauseIcon" onClick={() => pauseLesson(true)} />
    ) : (
      <PlayIcon data-testid="playIcon" onClick={() => pauseLesson(false)} />
    )}
    <StopIcon data-testid="stopIcon" onClick={stopLesson}></StopIcon>
    <LessonControllerTitle />
  </ButtonContainer>
);

const DialogMonitorSection = ({ dialogMonitor, updateDialogMonitor }) => (
  <PreferenceSection data-testid="preferenceSection">
    <GraySection>Dialog Monitor: </GraySection>
    <div>Lower Monitor</div>
    <Switch
      checked={dialogMonitor === 'upper'}
      onChange={updateDialogMonitor}
    />
    <div>Upper Monitor</div>
  </PreferenceSection>
);

const LessonStartedView = ({
  mode,
  timeRemaining,
  estimatedTime,
  status,
  system,
  pauseLesson,
  stopLesson,
  dialogMonitor,
  updateDialogMonitor,
  multiMediaAndHintReviews,
  showMediaAndReviewHintAction,
  executorResources,
}) => {
  const formattedTimeRemaining = formatTime(timeRemaining);
  const formattedEstimatedTime = formatTime(minToMillis(estimatedTime));

  const isDemoMode = mode === 'demo';
  const isSystemS80 = system === 's80';
  const isLessonStarted = status === LessonState.STARTED;

  return (
    <Container>
      <IdleTimer timeout={IdleTimeout} logoutOnTimeout={false} />
      {!isDemoMode && (
        <TimerDisplay
          timeRemaining={formattedTimeRemaining}
          estimatedTime={formattedEstimatedTime}
        />
      )}
      <ControlButtons
        system={system}
        isLessonStarted={isLessonStarted}
        pauseLesson={pauseLesson}
        stopLesson={stopLesson}
      />
      {isSystemS80 && (
        <DialogMonitorSection
          dialogMonitor={dialogMonitor}
          updateDialogMonitor={updateDialogMonitor}
        />
      )}
      {!isDemoMode && (
        <MultimediaAndHintReviewList
          multiMediaAndHintReviews={multiMediaAndHintReviews}
          showMediaAndReviewHintAction={showMediaAndReviewHintAction}
          executorResources={executorResources}
        />
      )}
    </Container>
  );
};

export default LessonStartedView;
